// extracted by mini-css-extract-plugin
export var mobileBreakpoint = "600";
export var tabletBreakpoint = "1024";
export var h1 = "_export-module--h-1--1zMe1";
export var h2 = "_export-module--h-2--rnXTV";
export var h3 = "_export-module--h-3--3VNBL";
export var genHeader = "_export-module--gen-header--1t3oi";
export var p1 = "_export-module--p-1--13Rs9";
export var p2 = "_export-module--p-2--3X2ws";
export var p3 = "_export-module--p-3--39V3L";